// extracted by mini-css-extract-plugin
module.exports = {"ExternalLink":"external-link_ExternalLink__uSGVK","ExternalLinkInText":"external-link_ExternalLinkInText__nAMmI","ExternalLinkButton":"external-link_ExternalLinkButton__oBCtD"};